// Facebook Ads Reports Enums

export const PAGE_TITLE = 'Facebook Ads Reports';
export const PAGE_SINGLE_TITLE = 'Facebook Ad Report';
export const LINK_URL = 'facebook-ads-reports';

export const SIDEBAR_OPTIONS = [
  {
    label: 'Campaigns',
    value: 'campaign',
    show: true,
    path: 'campaignName',
  },
  {
    label: 'Ad Sets',
    value: 'adSet',
    show: true,
    path: 'adSetName',
  },
  {
    label: 'Accounts',
    value: 'account',
    show: true,
    path: 'accountName',
  },
];

export const inputFields = {
  accountName: {
    label: 'Account Name',
    type: 'text',
    placeholder: 'Enter account name',
    required: true,
  },
  accountId: {
    label: 'Account ID',
    type: 'text',
    placeholder: 'Enter account ID',
    required: true,
  },
  campaignName: {
    label: 'Campaign Name',
    type: 'text',
    placeholder: 'Enter campaign name',
  },
  adSetName: {
    label: 'Ad Set Name',
    type: 'text',
    placeholder: 'Enter ad set name',
  },
  clicks: {
    label: 'Clicks',
    type: 'number',
    placeholder: 'Enter clicks',
  },
  impressions: {
    label: 'Impressions',
    type: 'number',
    placeholder: 'Enter impressions',
  },
  ctr: {
    label: 'CTR',
    type: 'number',
    placeholder: 'Enter CTR',
  },
  reach: {
    label: 'Reach',
    type: 'number',
    placeholder: 'Enter reach',
  },
  frequency: {
    label: 'Frequency',
    type: 'number',
    placeholder: 'Enter frequency',
  },
  amountSpent: {
    label: 'Amount Spent',
    type: 'number',
    placeholder: 'Enter amount spent',
  },
  client: {
    label: 'Client',
    type: 'select',
    placeholder: 'Select client',
    data_source: 'client',
  },
  reportDate: {
    label: 'Report Date',
    type: 'date',
    placeholder: 'Select report date',
    required: true,
  },
};

export const initialValues = {
  accountName: '',
  accountId: '',
  campaignName: '',
  adSetName: '',
  clicks: '',
  impressions: '',
  ctr: '',
  reach: '',
  frequency: '',
  amountSpent: '',
  client: '',
  reportDate: '',
};

export const view_all_table = {
  table_header: [
    'Account Name',
    'Campaign',
    'Ad Set',
    'Clicks',
    'Impressions',
    'CTR',
    'Date',
    'Action',
  ],
  table_data_mapping: [
    'accountName',
    'campaignName',
    'adSetName',
    'clicks',
    'impressions',
    'ctr',
    'reportDate',
  ],
};
